import clsx from 'clsx'

export const PersonaAvatarSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
} as const
export type PersonaAvatarSize = (typeof PersonaAvatarSize)[keyof typeof PersonaAvatarSize]

const sizeClass = (size: PersonaAvatarSize) => {
  switch (size) {
    case PersonaAvatarSize.SMALL:
      return 'h-7 w-7 rounded-lg text-[15px]'
    case PersonaAvatarSize.MEDIUM:
      return 'h-10 w-10 rounded-xl text-[21px]'
    case PersonaAvatarSize.LARGE:
      return 'h-16 w-16 rounded-2xl text-[34px]'
  }
}

const DEFAULT_EMOJI = '🧭'
const DEFAULT_COLOR = '#4A4E69'

interface Props {
  emoji?: string | null
  color?: string | null
  size?: PersonaAvatarSize
  /** 判定できないペルソナは色を落として区別する */
  muted?: boolean
}

/** ペルソナの見た目（絵文字＋軸の色）。カタログとサイト実体で同じ表現を使う。 */
const PersonaAvatar = ({ emoji, color, size = PersonaAvatarSize.SMALL, muted = false }: Props) => {
  const base = color || DEFAULT_COLOR
  return (
    <span
      className={clsx(
        'flex shrink-0 items-center justify-center leading-none',
        sizeClass(size),
        muted && 'opacity-40 grayscale'
      )}
      style={{ background: `${base}22`, boxShadow: `inset 0 0 0 1px ${base}44` }}
    >
      {emoji || DEFAULT_EMOJI}
    </span>
  )
}

export default PersonaAvatar
